import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { dashboardZone, invitationListApi, zoneWidgets } from "../../../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setInvitationList,
  setZoneWidgets,
} from "../../../redux";
import { Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import { Scenarios } from "../Scenarios";
import avatar from "../../../assets/images/avatar.svg";
import {
  ModalComp,
  Profile,
  Notifs,
  Add,
  Scenario,
  Automation,
  DeviceOrg,
} from "../../../shared";
import { AutoOrSen } from "../AutoOrsen";
import { useTranslation } from "react-i18next";

const MainPageMobileComp = (props) => {
  const { t } = useTranslation();
  const { setShowDevicsSection, showDevicsSection, today } = props;
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  const [showSecurityActivity, setShowSecurityActivity] = useState(false);
  const [activeSecurity, setActiveSecurity] = useState(true);
  const [showDashboard, setShowDashboard] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [openAddAutomationModal, setOpenAddAutomationModal] = useState(false);
  const [openDeviceOrgModal, setOpenDeviceOrgModal] = useState(false);

  const openDashboard = () => setShowDashboard(!showDashboard);
  const userInfo = useSelector((state) => state.userProfileInfo);
  const toggleProfile = () => {
    setOpenProfileModal(!openProfileModal);
    invitationListApi(token)
      .then((res) => {
        dispatch(setInvitationList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };
  const toggleNotification = () =>
    setOpenNotificationModal(!openNotificationModal);
  const toggleScenario = () => setOpenScenarioModal(!openScenarioModal);
  const toggleAddAutomation = () =>
    setOpenAddAutomationModal(!openAddAutomationModal);
  const toggleAdd = () => setOpenAddModal(!openAddModal);
  const toggleDeviceOrg = () => setOpenDeviceOrgModal(!openDeviceOrgModal);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  let [activeIndex, setActiveIndex] = useState(0);
  const [isShow, setIsShow] = useState(true);

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);

    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => {
            dispatch(setZoneWidgets(res.data.data));
          })
          .catch((err) => {
            if (err.response.status === 403) {
              Cookies.remove("token");
              props.history.push("/login");
            }
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          dispatch(setZoneWidgets([]));
        }
      });
  };
  const getGreetingTime = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return t("صبح بخیر");
    } else if (currentHour < 18 && currentHour >= 12) {
      return t("عصر بخیر");
    } else {
      return t("شب بخیر");
    }
  };

  const closeScenarios = () => {
    setIsShow(!isShow);
    // if (document.getElementById('scenarios').style.display === 'none') {
    //     document.getElementById('scenarios').style.display = 'flex';
    //     document.getElementById('devices').style.maxHeight = '47vh';
    // } else {
    //     document.getElementById('scenarios').style.display = 'none';
    //     document.getElementById('devices').style.maxHeight = '80vh';
    // }
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen((prevState) => !prevState);
    setShowDevicsSection(!showDevicsSection);
    if (!isOpen) {
      document.getElementById("phoneTopElements").style.height = "90vh";
    } else {
      document.getElementById("phoneTopElements").style.height = "unset";
    }
  };

  return (
    <React.Fragment>
      <ModalComp
        modal={openProfileModal}
        toggle={toggleProfile}
        component={<Profile />}
      />
      <ModalComp
        modal={openNotificationModal}
        toggle={toggleNotification}
        component={<Notifs />}
      />
      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenario}
        component={<Scenario />}
        dark={true}
      />
      <ModalComp
        modal={openAddAutomationModal}
        toggle={toggleAddAutomation}
        component={<Automation />}
        dark={true}
      />
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />
      <ModalComp
        modal={openDeviceOrgModal}
        toggle={toggleDeviceOrg}
        component={<DeviceOrg />}
        dark={true}
      />
      {showDashboard && (
        <div>
          <Col className="p-0">
            {/* <div className="dashboard position-relative d-flex pt-4" style={{ height: '110px' }}></div> */}
            <div className="dashboardElm dashboard d-flex flex-wrap pt-4 pb-5 px-2">
              {dashboardMine?.map((dash, index) => {
                const active = activeIndex === index ? true : false;
                return (
                  <span
                    className={`dashbordBtn cursor d-block fn ${
                      active ? "bgWhite" : "bgBlur text-white"
                    } mb-2 ml-2 mx-1 text-center`}
                    key={index}
                    onClick={() => dashboardDetail(dash, index)}
                  >
                    {dash.dashboard_caption}
                  </span>
                );
              })}
              {/* <span className="dashbordBtn d-block fn bgWhite mr-3 ml-2 text-center">خونه من</span>
                            <span className="dashbordBtn d-block fn bgBlur mx-2 text-center text-white">خونه شمال</span> */}
              <span
                className="dashbordIcon mx-2 text-center text-white cursor"
                onClick={toggleAdd}
              >
                +
              </span>
            </div>
          </Col>
        </div>
      )}
      <div
        id="phoneTopElements"
        className={`phoneTopElements p-3 position-relative ${
          showDashboard ? "phoneTopElementsRadius" : ""
        }`}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div
            className="userImgPhone position-relative"
            onClick={toggleProfile}
          >
            <img
              src={`https://assessn.mmaviot.com${userInfo.image}`}
              alt="avatar"
              className="w-100 h-100 rounded-circle"
            />
            <span className="activeUserPhone bg-priimary d-block position-absolute"></span>
          </div>
          <span
            className="verifyBtn bg-priimary text-center cursor"
            onClick={() => setShowSecurityActivity(!showSecurityActivity)}
          >
            <i
              className="icon-security text-white"
              style={{ fontSize: "25px" }}
            ></i>
          </span>
          <div className="todayWeatherPhone fn10 d-flex align-items-center justify-content-around">
            <i className="icon-airrr"></i>
            <p className="m-0">{today}</p>
          </div>
          <span
            className="notificationCirclePhone text-center icon-house position-relative rounded-circle"
            onClick={openDashboard}
          ></span>
          <span
            className="notificationCirclePhone position-relative rounded-circle icon-down-open-big text-center"
            onClick={toggle}
          ></span>
        </div>
        {/* {showSecurityActivity &&
                    <div className={`activitySecurityBtn ${activeSecurity ? 'bg-priimary' : 'bg-deactive'} my-3 py-2 cursor text-white d-flex align-items-center justify-content-between`}
                        onClick={() => setActiveSecurity(!activeSecurity)}>
                        <div className="d-flex align-items-center">
                            <i className="icon-security mx-3" style={{ fontSize: '25px' }}></i>
                            <p className="m-0 fn">سیستم امنیت {activeSecurity ? 'فعال' : 'غیر فعال'}</p>
                        </div>
                        <span className={`securityOnOffBtn bg-white rounded-circle ml-3 d-flex align-items-center justify-content-center ${!activeSecurity ? 'border-green' : ''}`}>
                            <i className={`icon-${activeSecurity ? 'off text-dark' : 'ok text-green'} fn`}></i>
                        </span>
                    </div>
                } */}
        <div className="my-2 d-flex">
          <Col className="p-0">
            <p className="m-0 text-right">{getGreetingTime()} </p>
          </Col>

          <Col className="roomWeather p-0 direction-ltr">
            <p className="m-0">32° C</p>
            <p className="m-0 fn12">Tehran</p>
          </Col>
        </div>
        <div id="scenarios">
          <Col className="p-0">
            {/* <Scenarios /> */}
            {isShow ? <AutoOrSen /> : <></>}
          </Col>
        </div>
        {isOpen && (
          <div className="text-right mb-4 py-4">
            <p className="mb-4">{t("اضافه کردن")}</p>
            <div
              className="addItems bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between"
              onClick={toggleDeviceOrg}
            >
              <div className="d-flex align-items-center">
                <span className="addItemsIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                  <i className="icon-plug" style={{ fontSize: "18px" }}></i>
                </span>
                <p className="m-0 fn">{t("دستگاه")}</p>
              </div>
              <p className="fn12 m-0 text-muted"></p>
            </div>
            <div
              className="addItems bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between"
              onClick={toggleAdd}
            >
              <div className="d-flex align-items-center">
                <span className="addItemsIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                  <i className="icon-house" style={{ fontSize: "25px" }}></i>
                </span>
                <p className="m-0 fn">{t("اتاق")}</p>
              </div>
              <p className="fn12 m-0 text-muted"></p>
            </div>
            <div
              className="addItems bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between"
              onClick={toggleScenario}
            >
              <div className="d-flex align-items-center">
                <span className="addItemsIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                  <i className="icon-lump" style={{ fontSize: "30px" }}></i>
                </span>
                <p className="m-0 fn">{t("سناریو")}</p>
              </div>
              <p className="fn12 m-0 text-muted"></p>
            </div>
            <div
              className="addItems bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between"
              onClick={toggleAddAutomation}
            >
              <div className="d-flex align-items-center">
                <span className="addItemsIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                  <i className="icon-clock" style={{ fontSize: "25px" }}></i>
                </span>
                <p className="m-0 fn">{t("اتوماسیون")}</p>
              </div>
              <p className="fn12 m-0 text-muted"></p>
            </div>
            <div className="addItems bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <span className="addItemsIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                  <i className="icon-cloudy" style={{ fontSize: "30px" }}></i>
                </span>
                <p className="m-0 fn">{t("اعضا")}</p>
              </div>
              <p className="fn12 m-0 text-muted"></p>
            </div>
          </div>
        )}
        <div
          className="closeScenarios position-absolute m-auto cursor p-15 "
          onClick={closeScenarios}
        ></div>
      </div>
    </React.Fragment>
  );
};

const MainPageMobile = withRouter(MainPageMobileComp);

export { MainPageMobile };
